const setUserToken = (state, token) => {
  state.token = token;
};

const setAgent = (state, agent) => {
  state.agent = agent;
};

export default {
  setUserToken,
  setAgent
};



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js